/**
 * Plan-page UI draft for `/onboarding/municipality/plan` ("Dein Angebot").
 * Persists Laufzeit / Admins / Schuleinheiten so the user can navigate away and
 * come back without losing their adjustments.
 *
 * Distinct from {@link MunicipalityPlanSelection}: that key is only committed on
 * «Auswählen» / «Kostenlos» and gates the onboarding guards. This draft never
 * unlocks downstream steps.
 */
export const MUNICIPALITY_PLAN_DRAFT_KEY = 'bn_municipality_plan_draft_v1';

export interface MunicipalityPlanDraft {
  selectedDuration: 1 | 2 | 3;
  extraAdmins: number;
  totalSchoolUnits: number;
}

export function saveMunicipalityPlanDraft(draft: MunicipalityPlanDraft): void {
  try {
    sessionStorage.setItem(MUNICIPALITY_PLAN_DRAFT_KEY, JSON.stringify(draft));
  } catch {
    // sessionStorage may be unavailable (private mode quota); silently drop.
  }
}

export function loadMunicipalityPlanDraft(): MunicipalityPlanDraft | null {
  try {
    const raw = sessionStorage.getItem(MUNICIPALITY_PLAN_DRAFT_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as MunicipalityPlanDraft;
  } catch {
    return null;
  }
}

export function clearMunicipalityPlanDraft(): void {
  sessionStorage.removeItem(MUNICIPALITY_PLAN_DRAFT_KEY);
}
